import { Box, Card, Grid2 } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useDocuments } from "../context/DocumentsContext";

const estilosdetabla = {
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "background.neutral",
    borderRadius: "0.5rem",
  },
  ".blueCell": {
    backgroundColor: "grid.azul",
  },
  ".orangeCell": {
    backgroundColor: "grid.rojo",
  },
  ".yellowCell": {
    backgroundColor: "grid.amarillo",
  },
  "& .totalFila": {
    fontWeight: "bold",
  },
  "& .categoriaFila": {
    color: "blue",
  },
  "& .familiaFila": {
    color: "green",
  },
  "& .negritaAzul": {
    color: "blue",
    fontWeight: "bold",
  },
  ".existenteCell": {
    backgroundColor: "#88DC8C",
  },
  "& .proveedorNoRegistrado": {
    backgroundColor: "#F4F86C",
  },
  "& .compraNoRegistrada": {
    backgroundColor: "#92CCFA",
  },
  "& .skyblueRow": {
    backgroundColor: "#92CCFA",
    color: "black",
  },
  "& .greenRow": {
    backgroundColor: "#88DC8C",
    color: "black",
  },
  "& .yellowRow": {
    backgroundColor: "#F4F86C",
    color: "black",
  },
  "& .redRow": {
    backgroundColor: "#F59694",
    color: "white",
  },
  "& .purpleRow": {
    backgroundColor: "#BEABE1",
    color: "black",
  },
  "& .orangeRow": {
    backgroundColor: "#F5C78A",
    color: "black",
  },
  "& .blueRow": {
    backgroundColor: "#92CCFA",
    color: "black",
  },
  "& .silverRow": {
    backgroundColor: "#F0F0F0",
    color: "black",
  },
};

export default function TablePage() {
  const { columns, rows } = useDocuments();
  return (
    <>
      <Card sx={{ p: 2, mb: 1 }} elevation={6}>
        <Grid2 container spacing={1}>
          <Box sx={estilosdetabla}>
            <div
              style={{
                padding: "1rem",
                height: "55vh",
                width: "100%",
              }}
            >
              <DataGrid
                sx={{
                  "& .MuiDataGrid-cell": {
                    border: "none",
                  },
                  "& .scrollArea--right": {
                    border: "20px",
                  },
                  "& .like-grid-blue": {
                    background: "#d0f2ff",
                  },
                  "& .like-grid-yellow": {
                    background: "#fff7cd",
                  },
                  "& .like-grid-red": {
                    background: "#ffe7d9",
                  },
                }}
                density="compact"
                // rowHeight={28}
                columns={columns}
                rows={rows}
              />
            </div>
          </Box>
        </Grid2>
      </Card>
    </>
  );
}
